module.exports = false;



//////////////////
// WEBPACK FOOTER
// /app/node_modules/babel-polyfill/node_modules/core-js/modules/_library.js
// module id = 108
// module chunks = 0